"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DISPLAY_TRANSACTION_FRAGMENT = void 0;
var client_1 = require("@apollo/client");
var UserFragment_1 = require("./UserFragment");
exports.DISPLAY_TRANSACTION_FRAGMENT = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  fragment DisplayTransaction on DisplayTransaction {\n    displayId\n    upc\n    brand\n    periodStartDate\n    periodEndDate\n    quantity\n    employee {\n      ...User  \n    }\n  }\n  ", "\n"], ["\n  fragment DisplayTransaction on DisplayTransaction {\n    displayId\n    upc\n    brand\n    periodStartDate\n    periodEndDate\n    quantity\n    employee {\n      ...User  \n    }\n  }\n  ", "\n"])), UserFragment_1.USER_FRAGMENT);
var templateObject_1;
